'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { Service } from '@/features/home/organisms/SolutionServices';
import useCheckIsMobileSize from '@/hooks/useCheckIsMobileSize';
import { RoundedButton, Typography } from '@/shared/ui/atoms';
import * as S from './styles';

interface SolutionServiceProps {
  service: Service;
}

const SolutionService = ({ service }: SolutionServiceProps) => {
  const router = useRouter();
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const isMobile = useCheckIsMobileSize();
  const serviceImage = `${baseImageUrl}/home/${isMobile ? 'm-' : 'pc-'}${service.serviceImage}`;
  const description = isMobile ? service.mobileDescription : service.description;

  const moveToLink = () => {
    router.push(service.link);
  };

  return (
    <div className={S.SolutionServiceContainer(service.position)}>
      <Image src={serviceImage} alt={service.service} width={1} height={1} className="w-full md:max-w-[624px] h-auto" unoptimized loading="lazy" />
      <div className="w-full max-w-[768px] md:max-w-[1440px] flex flex-col items-start justify-center">
        <Typography as="h3" className={S.ServiceName} style={S.ServiceNameTextStyle(service.serviceTextColor)}>
          {service.service}
        </Typography>
        <Typography as="h2" className={S.ServiceTitle} dangerouslySetInnerHTML={{ __html: service.title }} />
        <Typography className={S.ServiceDescription} dangerouslySetInnerHTML={{ __html: description }} />
        <RoundedButton label={`${service.service} 더 알아보기 →`} className={S.Button} onClick={moveToLink} />
      </div>
    </div>
  );
};

export default SolutionService;
